import { CloudOff, RefreshCw } from "lucide-react";
import { useSyncState } from "../lib/sync";

/** Shows only when something needs attention: offline, or changes not yet sent (spec 8). */
export function SyncBadge() {
  const { online, pending } = useSyncState();
  if (online && pending === 0) return null;
  return (
    <span role="status" className="inline-flex items-center gap-1.5 rounded-full border border-mist px-3 py-1 text-sm text-ink-soft">
      {online ? <RefreshCw aria-hidden className="size-4" /> : <CloudOff aria-hidden className="size-4" />}
      {online ? `Niet gesynct (${pending})` : pending ? `Offline, niet gesynct (${pending})` : "Offline"}
    </span>
  );
}
